<template>
  <AppInputCurrency
    :value="inputValue"
    v-bind="$attrs"
    :data-test="dataTest"
    @change="v => (inputValue = v)"
    @blur="$emit('blur', $event)"
  >
    <template #append-outer><slot name="append-outer"/></template>
  </AppInputCurrency>
</template>

<script>
import { computed } from "vue";
import AppInputCurrency from "./AppInputs/AppInputCurrency.vue";
export default {
  name: "AppMoneyField",
  components: { AppInputCurrency },
  props: {
    value: {
      type: Number,
      default: null
    },
    dataTest: {
      type: String,
      default: null
    }
  },
  setup(props, ctx) {
    const inputValue = computed({
      get() {
        if (props.value === "") return null;
        if (props.value === 0) return 0;
        if (!props.value || Number.isNaN(Number(props.value))) return null;
        return props.value / 100;
      },
      set(v) {
        if (v === "") {
          ctx.emit("input", null);
          return;
        }
        v = Number(String(v).replace(",", ".")); // some reason vue-currency-input does not return with . for all languages >:c
        if (v === 0) ctx.emit("input", 0);
        else if (!v || Number.isNaN(Number(v))) ctx.emit("input", null);
        else ctx.emit("input", Math.round(v * 100));
      }
    });

    return {
      inputValue
    };
  }
};
</script>
